import React, { Component } from "react";
import { observer } from "mobx-react";
import { computed } from "mobx";
import { withTranslation } from "react-i18next";
import { Button, Header, Icon, Message } from "semantic-ui-react";
import PropTypes from "prop-types";
import Customer from "~/models/Customer";
import UiMeet3dLevel from "~/constants/UiMeet3d/UiMeet3dLevel";
import Provider from "~/models/Provider";
import Subscription from "~/models/Subscription/Subscription";
import TourUiMeet3dLevelOptions from "~/constants/Tour/TourUiMeet3dLevelOptions";
import CommonHelper from "~/utils/CommonHelper";
import SimpleActiveSubscriptionCard from "~/modules/BillingCentral/components/SimpleActiveSubscriptionCard";
import OtherProduct from "~/models/OtherProduct";
import UiMeet3dSubscriptionStatisticGroup from "~/modules/UiMeet3d/components/UiMeet3dSubscriptionStatisticGroup";
import ProviderStatistic from "~/models/Provider/ProviderStatistic";
import CustomerStatistic from "~/models/Customer/CustomerStatistic";
import UiMeet3dSubscriptionExceededLimitsMessage from "~/modules/UiMeet3d/components/UiMeet3dSubsciptionExceededLimitsMessage";

@observer
class UiMeet3dHomeContent extends Component {
  @computed
  get uiMeet3dLevelCoalescedTranslationKey() {
    const tourUiMeet3dLevelOption = TourUiMeet3dLevelOptions().find(item => item.value === this.uiMeet3dLevelCoalesced);

    return typeof tourUiMeet3dLevelOption !== "undefined" ? tourUiMeet3dLevelOption.text : null;
  }

  @computed
  get uiMeet3dLevelCoalesced() {
    const { actualUser } = this.props;

    if (this.isProvider) {
      return actualUser.uiMeet3dLevelCoalesced;
    }

    if (
      this.isCustomer &&
      actualUser.uiMeet3dLevel === null &&
      actualUser.providerDefaults &&
      actualUser.providerDefaults.uiMeet3dLevel
    ) {
      return actualUser.providerDefaults.uiMeet3dLevel;
    }

    return actualUser.uiMeet3dLevel;
  }

  @computed
  get isProvider() {
    const { actualUser } = this.props;

    return actualUser instanceof Provider;
  }

  @computed
  get isCustomer() {
    const { actualUser } = this.props;

    return actualUser instanceof Customer;
  }

  render() {
    const {
      t,
      subscription,
      otherProducts,
      redirectToGeneralPageCallback,
      redirectToSubscriptionCreatePageCallback,
      statistic,
      statisticModule,
    } = this.props;

    const toChangeYourUiMeet3dLevel = CommonHelper.firstLetterLower(t("clientPanelMisc:toChangeYourUiMeet3dLevel"));

    return (
      <div className="ui-meet-3d-home-content">
        <Header as="h2">
          <Header.Content>{t("home")}</Header.Content>
        </Header>
        {subscription && (
          <>
            <UiMeet3dSubscriptionStatisticGroup
              subscription={subscription}
              statistic={statistic}
              statisticModule={statisticModule}
            />
            <UiMeet3dSubscriptionExceededLimitsMessage subscription={subscription} statistic={statistic} />
            <SimpleActiveSubscriptionCard subscription={subscription} otherProducts={otherProducts} />
          </>
        )}
        {!subscription && (
          <Message icon className="call-to-action">
            <Icon name="warning circle" />
            <Message.Content>
              <Message.Header>{t("billingCentral:noActiveSubscription")}</Message.Header>
              {t("clientPanelMisc:uiMeet3dSubscriptionDescription1")}{" "}
              {t("clientPanelMisc:uiMeet3dSubscriptionDescription2")}
              <Button basic floated="right" size="big" onClick={() => redirectToSubscriptionCreatePageCallback()}>
                {t("billingCentral:subscription")}
              </Button>
            </Message.Content>
          </Message>
        )}
        {this.uiMeet3dLevelCoalesced !== UiMeet3dLevel.VIDEO && (
          <Message warning>
            <Message.Header>{t("warning")}</Message.Header>
            <p>
              {t("clientPanelMisc:yourUiMeet3dLevelIs", {
                uiMeet3dLevel: t(this.uiMeet3dLevelCoalescedTranslationKey),
              })}
              .
              <br />
              {t("clientPanelMisc:uiMeet3dLevelNotOptimal")}
              <br />
              <a onClick={() => redirectToGeneralPageCallback()} style={{ cursor: "pointer" }}>
                {t("clickHere")}
              </a>
              , {toChangeYourUiMeet3dLevel}.
            </p>
          </Message>
        )}
      </div>
    );
  }
}

UiMeet3dHomeContent.propTypes = {
  t: PropTypes.func.isRequired,
  actualUser: PropTypes.oneOfType([PropTypes.instanceOf(Provider), PropTypes.instanceOf(Customer)]),
  subscription: PropTypes.instanceOf(Subscription),
  otherProducts: PropTypes.arrayOf(PropTypes.instanceOf(OtherProduct)),
  redirectToGeneralPageCallback: PropTypes.func.isRequired,
  redirectToSubscriptionCreatePageCallback: PropTypes.func.isRequired,
  statistic: PropTypes.oneOfType([PropTypes.instanceOf(ProviderStatistic), PropTypes.instanceOf(CustomerStatistic)]),
  statisticModule: PropTypes.string,
};

UiMeet3dHomeContent.defaultProps = {
  statisticModule: "uiMeet3dActiveToursCount",
};

export default withTranslation()(UiMeet3dHomeContent);
